import React, { FC } from "react";
// libs
import NextImage from "next/image";
// components
import MainInput from "src/components/containers/home/sections/MainInput";
// hooks
import { useAppDispatch, useAppSelector } from "src/hooks";
// redux
import { variablesStateKeySelector, updateVariable } from "src/redux/slices/variables";
import { permissionSelector, authSelector } from "src/redux/slices";
// const
import {
  HIDE_GEOLOCATION_MODAL_ON_MAIN_PAGE,
  HIDE_GEOLOCATION_MODAL_ON_SEARCH_PAGE,
  HIDE_GEOLOCATION_MODAL_EVERYWHERE,
} from "src/constants/variables";
import { GEOLOCATION } from "src/constants/permissions";
import {
  CatImgWrapper,
  Container,
  DogImgWrapper,
  DogSmallImgWrapper,
  SearchWrapper,
  HeroTitle,
  WomanImgWrapper,
  WomanSmallImgWrapper,
  Wrapper,
} from "./search-styles";

export interface ISearchSection {}

const SearchSection: FC<ISearchSection> = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(authSelector);

  const hideGeoModal = useAppSelector(
    variablesStateKeySelector(HIDE_GEOLOCATION_MODAL_ON_MAIN_PAGE),
  );
  const hideGeolocationModalEverywhere = useAppSelector(
    variablesStateKeySelector(HIDE_GEOLOCATION_MODAL_EVERYWHERE),
  );
  const geolocationPermission = useAppSelector(permissionSelector(GEOLOCATION));
  const isPromptPermission = geolocationPermission === "prompt";
  const hideModal = hideGeoModal || hideGeolocationModalEverywhere || !isPromptPermission;

  const handleHideGeoModal = () => {
    dispatch(updateVariable({ name: HIDE_GEOLOCATION_MODAL_ON_MAIN_PAGE, value: true }));
  };

  const handleSuccessGeoModal = () => {
    dispatch(updateVariable({ name: HIDE_GEOLOCATION_MODAL_ON_SEARCH_PAGE, value: true }));
  };

  return (
    <Wrapper>
      <Container>
        <HeroTitle>Find a vet near&nbsp;you</HeroTitle>

        <SearchWrapper>
          <CatImgWrapper>
            <NextImage src="/illustrations/Cat+Vase.svg" priority height={213} width={195} />
          </CatImgWrapper>

          <MainInput
            searchValue={user.location || ""}
            placeholder="For any animal"
            hideGeoModal={hideModal}
            onGeoModalClose={handleHideGeoModal}
            onGeoModalSuccess={handleSuccessGeoModal}
          />

          <WomanImgWrapper>
            <NextImage src="/illustrations/Woman+Plant.svg" priority width={325} height={566} />
          </WomanImgWrapper>
        </SearchWrapper>
      </Container>
      <DogImgWrapper>
        <NextImage src="/illustrations/Dog+Cactus.svg" priority height={337} width={276} />
      </DogImgWrapper>
      <DogSmallImgWrapper>
        <NextImage
          src="/illustrations/Dog+Cactus.svg"
          priority
          height={183}
          width={149}
          objectPosition={-16}
        />
      </DogSmallImgWrapper>
      <WomanSmallImgWrapper>
        <NextImage
          src="/illustrations/Woman+Plant.svg"
          priority
          width={175}
          height={306}
          objectPosition={64}
        />
      </WomanSmallImgWrapper>
    </Wrapper>
  );
};

export default SearchSection;
